// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';

import { Card, InfoBanner, Th, Td } from '../../../components/WorkflowFormPrimitives';
import { fmt, formatWithCommas, cleanCurrencyInput } from '../../../utils/formatCurrency';
import { useCompanyContext } from '../../../context/CompanyContext';
import { PARACHUTE_STEP_INFO } from '../parachuteCopy';
import { getUniqueIndividualsFromForm } from './uniqueIndividuals';

export const CICBonusesContent = ({ formData, setFormData }) => {
  const { currentAnalysisId } = useCompanyContext();
  const uniqueIndividuals = getUniqueIndividualsFromForm(formData);
  const [data, setData] = useState(formData.cicBonusData || {});
  const [focusedRowId, setFocusedRowId] = useState<string | null>(null);
  const lastIncomingCicJson = useRef(null);

  useEffect(() => {
    lastIncomingCicJson.current = null;
  }, [currentAnalysisId]);

  useEffect(() => {
    const incoming = formData.cicBonusData || {};
    const json = JSON.stringify(incoming);
    if (lastIncomingCicJson.current !== json) {
      lastIncomingCicJson.current = json;
      setData(incoming);
    }
  }, [formData.cicBonusData]);

  const update = (id, v) => setData((p) => ({ ...p, [id]: +v || 0 }));
  useEffect(() => {
    setFormData((p) => ({ ...p, cicBonusData: data }));
  }, [data]);
  return (
    <div className="space-y-3">
      <Card padding={false}>
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <Th>Name</Th>
              <Th>Change in Control Bonus Amount</Th>
              <Th className="bg-emerald-50/50">Parachute value</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {uniqueIndividuals.map((ind) => (
              <tr key={ind.id} className="hover:bg-gray-50/50">
                <Td highlight>
                  <div>
                    <span className="text-gray-900">{ind.name}</span>
                    <br />
                    <span className="text-xs text-gray-400">{ind.title}</span>
                  </div>
                </Td>
                <Td>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={focusedRowId === ind.id ? String(data[ind.id] ?? '') : formatWithCommas(data[ind.id] ?? '')}
                    onChange={(e) => update(ind.id, cleanCurrencyInput(e.target.value))}
                    onFocus={() => setFocusedRowId(ind.id)}
                    onBlur={() => setFocusedRowId(null)}
                    className="w-32 h-8 px-2 text-xs border border-gray-300 rounded-md"
                    placeholder="0"
                  />
                </Td>
                <Td className="bg-emerald-50/30 font-bold text-emerald-700">{fmt(data[ind.id] || 0)}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <InfoBanner showIcon>
        <strong>CIC bonuses:</strong> {PARACHUTE_STEP_INFO.cicBonus}
      </InfoBanner>
    </div>
  );
};
